export const RETRIEVE_ACCOUNTS_SUCCESS = 'RETRIEVE_ACCOUNTS_SUCCESS';